const $ = require('jquery');
const cookieUtils = require('cookie-utils');

const THD_PERSIST_COOKIE_NAME = 'THD_PERSIST=';
const MINI_CART_COUNT_PROPERTY = 'I1';
const THD_MINICART_CRUMB_NAME = 'C6=';
const THD_MINICART_CRUMB_END_CHARS = '}:;';

class MyCart {
  constructor() {
    this.cartThrottle = true;
    this.updateCartInfo = this.updateCartInfo.bind(this);
  }

  static forceInteger(value) {
    return value ? parseInt(value, 10) : 0;
  }

  _getBlindsCount() {
    return MyCart.forceInteger(
      cookieUtils.readBrowserCookie('Blinds_ComCartSamplesCount'),
    );
  }

  _parseMinicartItemCount(cookie) {
    // if the THD_PERSIST cookie isn't there, then we cannot find the crumb with the cart item count
    if (cookie.indexOf(THD_PERSIST_COOKIE_NAME) === -1) {
      return 0;
    }

    const decodedCookie = decodeURIComponent(cookie);

    // if we do not see a C6 cookie crumb, then we cannot parse the cart item count
    if (decodedCookie.indexOf(THD_MINICART_CRUMB_NAME) === -1) {
      return 0;
    }

    // need to offset by 3 so we don't include the actual 'C6=' name in the minicart string
    const minicartCrumbStartIndex =
      decodedCookie.indexOf(THD_MINICART_CRUMB_NAME) + 3;
    // offsetting by 1 just so we can include the '}' in the indexOf call, to make it more failure proof
    // and to make sure that the ending curly bracket is included in the minicart string
    const minicartCrumbEndIndex =
      decodedCookie.indexOf(
        THD_MINICART_CRUMB_END_CHARS,
        minicartCrumbStartIndex,
      ) + 1;
    const thdMiniCartString = decodedCookie.substring(
      minicartCrumbStartIndex,
      minicartCrumbEndIndex,
    );

    let minicartItemCount;
    try {
      const miniCartCookieObject = JSON.parse(thdMiniCartString);
      minicartItemCount = MyCart.forceInteger(
        miniCartCookieObject[MINI_CART_COUNT_PROPERTY],
      );
    } catch (_) {
      // if the format of the cookie ever changes, the parse might throw an exception
      // in that situation we want to display 0 for the mini-cart count
      minicartItemCount = 0;
    }

    return minicartItemCount;
  }

  _getTotal() {
    const total =
      this._getBlindsCount() + this._parseMinicartItemCount(document.cookie);
    return total > 99 ? '99+' : total;
  }

  updateCartInfo() {
    const total = this._getTotal();
    const isTotalOver99 = total === '99+';
    const isTotalBetween10and99 = !isTotalOver99 && total > 9;
    const isCartEmpty = total === 0;

    $('.MyCart')
      .find('.MyCart__icon__count')
      .text(total)
      .toggleClass('MyCart__icon__count--has-items', !isCartEmpty)
      .toggleClass('MyCart__icon__count--over-9', isTotalBetween10and99)
      .toggleClass('MyCart__icon__count--over-99', isTotalOver99);
  }

  init() {
    $(document).on('cartUpdated ready', this.updateCartInfo);
  }
}

module.exports = new MyCart();
